import { render, staticRenderFns } from "./CallForHelpInfo.vue?vue&type=template&id=53d1fe92&"
import script from "./CallForHelpInfo.vue?vue&type=script&lang=js&"
export * from "./CallForHelpInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports